<div class="page-wrapper section-hr-direct">
    <app-left-menu></app-left-menu>

    <div id="main-container">

        <app-header [title]="title"></app-header>
        <div style="height: 40px;display: block;">&nbsp;</div>
        <div class="page-content settings">
            <div class="page-content">
                <div class="content">
                    <a [routerLink]="['/settings/changepassword']"
                        class="panel-link change-password">{{'Settings.ChangePassword'|translate}}</a>
                </div>
            <div *ngIf="SubscribeToTextNotifications.IsDisplay">                
                <div style="margin-bottom: 20px;">{{this.SubscribeToTextNotifications.Header}}</div>
                <div class="form-check" *ngFor="let item of SubscribeToTextNotifications.Options">                  
                  <input name="list-group" style="cursor: pointer;" (click)="this.setSubscribeToTextNotifications(item.Value)" type="radio" [checked]="item.IsSelected">
                  {{item.Text}}
                </div>
            </div>
            </div>
        </div>
    </div>